import { Box, Button } from '@mui/material';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { Form, FormikProvider, useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { putEditCalender } from '../../../redux/features/CRDslice';

export default function EditPopup({ lastSessionDate, row, loading, setChange, setOpen, dispatchFn, setSelectedRows }) {
  const dispatch = useDispatch();
  const apiHelper = useHandleApiResponse();
  const submitHandler = (data) => {
    const obj = {
      ...data,
      session_schedule_id: Array.isArray(row) ? row : row?.session_schedule_id,
      week_day: dayjs(data?.session_date, 'YYYY-MM-DD').day(),
    };
    dispatch(dispatchFn ? dispatchFn(obj) : putEditCalender(obj)).then((res) =>
      apiHelper(res, {
        onSuccess: () => {
          setChange((p) => !p);
          setOpen(false);
          Array.isArray(row) && setSelectedRows([]);
        },
      }),
    );
  };

  const validationSchema = Yup.object({
    session_date: Yup.mixed().nullable().required('Session date is required'),
    /* .test('within-7-days', 'Session date must be within 7 days', (value) => {
        if (!value || !lastSessionDate) return false;

        const selectedDate = dayjs(value);
        const lastDate = dayjs(lastSessionDate);

        return selectedDate.diff(lastDate, 'day') <= 7;
      }) */ from_time: Yup.string().nullable().required('From time is required'),
    to_time: Yup.string()
      .required('To time is required')
      .test('is-after', 'To time must be greater than From time', function (value) {
        const { from_time } = this.parent;

        if (!from_time || !value) return true;

        return value > from_time; // works for HH:mm format
      }),
  });

  const formik = useFormik({
    enableReinitialize: true,
    onSubmit: submitHandler,
    validationSchema: validationSchema,
    initialValues: {
      session_date: Array.isArray(row?.session_date) ? null : (row?.session_date ?? null),
      from_time: row?.from_time ?? null,
      to_time: row?.to_time ?? null,
    },
  });

  return (
    <FormikProvider value={formik}>
      <Form>
        <Box display={'flex'} flexDirection={'column'} gap={1}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Session Date"
              disablePast
              value={formik.values.session_date ? dayjs(formik.values.session_date, 'YYYY-MM-DD') : null}
              onChange={(value) => formik.setFieldValue('session_date', value ? value.format('YYYY-MM-DD') : null)}
              slotProps={{
                textField: {
                  error: Boolean(formik.errors.session_date),
                  helperText: formik.errors.session_date,
                  fullWidth: true,
                },
              }}
            />

            <TimePicker
              label={'From Time'}
              ampm
              value={formik.values.from_time ? dayjs(formik.values.from_time, 'HH:mm') : null}
              onChange={(value) => formik.setFieldValue('from_time', value ? value.format('HH:mm') : null)}
              onBlur={() => formik.setFieldTouched('from_time', true)}
              slotProps={{
                textField: {
                  error: formik.touched.from_time && Boolean(formik.errors.from_time),
                  helperText: formik.touched.from_time && formik.errors.from_time,
                  fullWidth: true,
                },
              }}
            />
            <TimePicker
              label={'To Time'}
              onBlur={() => formik.setFieldTouched('to_time', true)}
              ampm
              value={formik.values.to_time ? dayjs(formik.values.to_time, 'HH:mm') : null}
              onChange={(value) => formik.setFieldValue('to_time', value ? value.format('HH:mm') : null)}
              slotProps={{
                textField: {
                  error: formik.touched.to_time && Boolean(formik.errors.to_time),
                  helperText: formik.touched.to_time && formik.errors.to_time,
                  fullWidth: true,
                },
              }}
            />
          </LocalizationProvider>
          <Button variant="outlined" type="submit" disabled={loading}>
            {loading ? 'Loading...' : 'Submit'}
          </Button>
        </Box>
      </Form>
    </FormikProvider>
  );
}
